import { InputText } from '../../../classes/input-text';

export class StripeFormFields {
	email = new InputText({
		key: 'email',
		label: 'Billing Email',
		placeholder: '',
		required: true,
		pattern: 'email',
		value: '',
	});
}
